<i18n src="@/locales/views/user_profile/edit_password.yml" lang="yaml"></i18n>

<template>

  <alert-danger :errors_data="std_err" />

  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("labels.current_password") }}
              </label>
              <div class="mt-1">
                <input
                  type="password"
                  v-model="current_password"
                  :class="['input-text']"
                />
              </div>
            </div>
          </div>
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('password')]">
                {{ $t("labels.new_password") }}
              </label>
              <div class="mt-1">
                <input
                  type="password"
                  v-model="new_password"
                  :class="['input-text', isInvalid('password')]"
                />
                <p class="mt-2 text-sm text-gray-500">{{ $t("labels.min_pass_length") }}</p>
                <p class="mt-2 text-sm text-gray-500">{{ $t("labels.min_one_number") }}</p>
                <p class="mt-2 text-sm text-gray-500">{{ $t("labels.min_one_lower") }}</p>
                <p class="mt-2 text-sm text-gray-500">{{ $t("labels.min_one_upper") }}</p>
              </div>
            </div>
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('password_confirmation')]">
                {{ $t("labels.new_password_confirmation") }}
              </label>
              <div class="mt-1">
                <input
                  type="password"
                  v-model="new_password_confirmation"
                  :class="['input-text', isInvalid('password_confirmation')]"
                />
              </div>
            </div>
         
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          
          <success-button
            v-if="!proc_save_button"
            @click.prevent="updatePassword()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RequesterChangeData from "../requesters/change_data.js";

export default {
  name: "UserProfileEditPassword",
  data: function () {
    return {
      proc_save_button: false,
      current_password: null,
      new_password: null,
      new_password_confirmation: null,
    };
  },

  methods: {
    updatePassword: async function () {
      this.proc_save_button = true;
      try {
        let response = await RequesterChangeData.updatePassword(
          this.current_password,
          this.new_password,
          this.new_password_confirmation
        );
        this.current_password = null;
        this.new_password = null;
        this.new_password_confirmation = null;
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.$router.push({ name: "home_path" });
      } catch (error) {
        if (error.response.status == 422) {
          this.current_password = null;
          this.new_password = null;
          this.new_password_confirmation = null;
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
        this.proc_save_button = false;
      }
    }
  },
  created() {
    this.checkIfAuthenticated();
  }
};
</script>
